import _ from 'lodash';
import config from 'client/shared/config';
import { toast } from 'react-toastify';

import {
	observable,
	action,
	computed,
	runInAction
} from 'mobx';

import BaseStore from './base-store';
// import Subscription from './subscription';

const { routes } = config;

class SubscriptionStore extends BaseStore {
	apiRoute = routes.subscription;

	/**
	 * Observables & Computeds
	 */

	@computed
	get data () {
		return {
			subscription: this._data.item
		};
	}

	@computed
	get subscriptions () {
		return this._items;
	}
    
    
	getSubscriptionsByArtist (artistID) {
		return this._items.filter(s=>s.artistID === artistID);
	}
}

const subscriptionStore = new SubscriptionStore();
export default subscriptionStore;
